module.exports = __webpack_public_path__ + "img/FE_A3_front_en.4f4774c4.png";